export const OBIE_LINK = "https://www.obieinsurance.com/partner/constitution-lending";